import React from "react";
import {
    Button,
    IconButton,
    makeStyles,
    Typography,
} from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import CloseIcon from "@material-ui/icons/Close";

const useStyles = makeStyles((theme) => ({
    root: {
        borderRadius: 25,
        background: "#0E0E0E",
        paddingBottom: 20,
        position: "relative",
        "& .MuiDialogContent-root": {
            flex: "none !important",
        },
        "& .MuiDialogActions-root": {
            marginRight: "0px !important",
        },
    },
    closeButton: {
        position: "absolute",
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: "#fff",
        zIndex: 10,
    },
    titleMain: {
        fontStyle: "normal",
        fontWeight: "800",
        fontSize: "34px",
        lineHeight: "40px",
        color: "#fff",
        textAlign: "center",
        marginTop: "12px",
    },
    subMain: {
        fontStyle: "normal",
        fontWeight: "500",
        fontSize: "16px",
        lineHeight: "24px",
        color: "#fff",
    },
    actionButton: {
        width: "120px",
        height: "40px",
        background: "#f6f6f6",
        borderRadius: "10px",
        color: "#2A2A2B",
        cursor: "pointer",
        fontWeight: 600,
        margin: "0 12px",
    },
    actionsWrapper: {
        display: "flex",
        justifyContent: "center",
        marginTop: 12,
    },
}));

export default function ContactUsModal({
    open,
    handleClose,
    onMailClick,
    onCallClick,
}) {
    const classes = useStyles();

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="contact-us-title"
            fullWidth
            maxWidth="xs"
            PaperProps={{
                classes: {
                    root: classes.root,
                },
            }}
        >
            {/* Close button */}
            <IconButton
                aria-label="close"
                className={classes.closeButton}
                onClick={handleClose}
            >
                <CloseIcon />
            </IconButton>

            <DialogTitle id="contact-us-title" style={{ textAlign: "center" }}>
                <Typography className={classes.titleMain}>Contact Us</Typography>
            </DialogTitle>

            <DialogContent>
                <DialogContentText
                    id="contact-us-description"
                    style={{ textAlign: "center", fontSize: "17px" }}
                >
                    <Typography className={classes.subMain}>
                        Get in touch with your Relationship Manager <br />
                        RM - <strong>Suhasini Raina</strong>
                    </Typography>
                </DialogContentText>
            </DialogContent>

            <DialogActions className={classes.actionsWrapper}>
                <button className={classes.actionButton} onClick={onMailClick}>
                    Mail RM
                </button>
                <button className={classes.actionButton} onClick={onCallClick}>
                    Set Up a Call
                </button>
            </DialogActions>
        </Dialog>
    );
}
